<script lang="ts">
  import { Link } from '@athena-lib/Link';
  import Image from '@athena-lib/Image/Image.svelte';
  import type { PaymentProviderIcon } from './types';

  type Props = {
    paymentProviderIcons: PaymentProviderIcon[];
  };

  const { paymentProviderIcons }: Props = $props();
  const year = new Date().getFullYear();
</script>

<div class="flex w-full flex-col items-center justify-center gap-8 bg-st-black py-8 text-st-white">
  <div class="flex flex-wrap items-center justify-center gap-x-10 gap-y-5">
    {#each paymentProviderIcons as icon}
      <Link href={icon.link?.href}>
        <Image src={icon.icon.url} alt={icon.icon.alt} loading="lazy" />
      </Link>
    {/each}
  </div>
  <div class="text-center text-sm">&copy; StickerApp {year}</div>
</div>
